import { render, staticRenderFns } from "./CommonWidgetContent.vue?vue&type=template&id=8440d91e"
import script from "./CommonWidgetContent.vue?vue&type=script&lang=js"
export * from "./CommonWidgetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports